<div class="wrapper p-2">
    <div class="info-header">
        <i class="fas fa-info-circle mr-1"></i>
        <span class="info-font mr-2">Extensões permitidas:</span>
        <span class="text-highlight info-font heavy">PDF</span>
    </div>

    @for (item of $value()?.fileName; track item; let i = $index) {
        <div class="file-container p-2 mt-1">
            <label class="m-0 py-1 px-2">
                <i class="fas fa-folder-open mr-1"></i>
                <span>Escolher arquivo</span>
                <input type="file" accept="application/pdf"
                       [disabled]="$disabled()"
                       (change)="changeFile($event)"
                >
            </label>

            <span class="ml-2 info-font file-name">{{$fileNames()[i]}}</span>

            @if (!$disabled()) {
                <i class="fas fa-times-circle ml-2" matTooltip="Remover arquivo" (click)="removeFile(i)" (keyDown)="removeFile(i)"></i>
            }
        </div>
    }

    <div class="file-container p-2 mt-1">
        <label class="m-0 py-1 px-2">
            <i class="fas fa-folder-open mr-1"></i>
            <span>Escolher arquivo</span>
            <input type="file" accept="application/pdf" #anchorFileRef
                   [disabled]="$disabled()"
                   (change)="changeFile($event)"
            >
        </label>
        <span class="ml-2 info-font font-italic">Nenhum arquivo selecionado</span>
    </div>
</div>
